export const base = {
    roundUpSavings: {
        enabled: false,
        _description:
            'Enables new round up savings feature that uses money automation engine to set rules to save specified amounts for specific transactions',
    },
};
